import React from 'react';
import { WfFeedbackFramePreview } from '../components/frames/WfFeedbackFramePreview';
import { siteConfig } from '../data/siteConfig';
export function Contact() {
  const {
    support
  } = siteConfig;
  return <div className="mx-auto grid max-w-page gap-14 px-5 py-14 md:px-10 md:py-20 lg:grid-cols-[1fr_1.3fr] lg:gap-24" data-id="element-457" data-mp="1qobjw349e1ap">
      <div data-id="element-458" data-mp="1lrl1h94zetm4">
        <h1 className="font-display text-[46px] font-medium leading-[1.03] text-ink md:text-[64px]" data-id="element-459" data-mp="1lr1kpvr2ib9o">We’re here to help.</h1>
        <p className="mt-5 max-w-md text-[17px] leading-relaxed text-ink-muted" data-id="element-460" data-mp="xycsw26i7u3e">
          Questions about the mask, the user manual or an order? Call us during support hours, or send a message.
        </p>
        <div className="mt-10 border-t border-ink pt-6" data-id="element-461" data-mp="12zscdpt19sjo">
          <p className="text-[14px] text-ink-muted" data-id="element-462" data-mp="12y7im2ejmdmv">Phone</p>
          <a href={support.phoneHref} className="mt-1 inline-flex min-h-[44px] items-center font-display text-4xl text-ink hover:text-bronze-deep" data-id="element-463" data-mp="f9o5n9kjtcog">
            {support.phone}
          </a>
        </div>
        <div className="mt-6 border-t border-line pt-6" data-id="element-464" data-mp="15ex8j27pjyzs">
          <p className="text-[14px] text-ink-muted" data-id="element-465" data-mp="19gih4bd7lr46">Support hours ({support.timezone})</p>
          <dl className="mt-3 space-y-2 text-[16px] text-ink" data-id="element-466" data-mp="1e80mrcq6gfvh">
            {support.hours.map(h => <div key={h.days} className="flex max-w-xs justify-between gap-4" data-id="element-467" data-mp="1j7d6holr56tu">
                <dt data-id="element-468" data-mp="mgkqeqytjes2">{h.days}</dt>
                <dd className="tabular-nums" data-id="element-469" data-mp="mhmcdqhdhlok">{h.time}</dd>
              </div>)}
          </dl>
        </div>
      </div>
      <div className="lg:pt-3" data-id="element-470" data-mp="qig0ajutf0hg">
        <WfFeedbackFramePreview data-id="element-471" data-mp="vh94flo7pf4y" />
      </div>
    </div>;
}